import { Decision } from './schema'

/**
 * A canned public reply. `code` links the macro to a decision so picking
 * "rejected" pre-fills the rejection wording; macros with an empty code are
 * only applied when the reviewer selects them by hand.
 */
export interface Macro {
  title: string
  body: string
  code: Decision | ''
}

export const BLANK_MACRO: Macro = { title: 'Blank Message', body: '', code: '' }

/**
 * Marketplace item review macros. `{item}`, `{provider}` and `{price}` are
 * replaced with the item being reviewed, see `applyMacroTokens`.
 */
export const PROVIDER_ITEM_MACROS: Macro[] = [
  {
    title: 'Accept Messaging',
    body: 'Thank you for submitting {item} for the Marketplace. We have reviewed the item and are pleased to inform you that it has been accepted and is now available to families.',
    code: 'accepted',
  },
  {
    title: 'Reject Messaging',
    body: 'We have reviewed {item} and are unable to publish it in the Marketplace at this time because it does not meet the program guidelines.\nPlease update the item details and submit it again for review.',
    code: 'rejected',
  },
  {
    title: 'Reject - Pricing',
    body: 'We have reviewed {item} and are unable to publish it in the Marketplace at the submitted price of {price}.\nPlease review the pricing guidelines for your category, update the item and submit it again for review.',
    code: 'rejected',
  },
  {
    title: 'Reject - Missing Information',
    body: 'We have reviewed {item} and need more information before it can be published in the Marketplace. The description, images or category do not describe the goods or services clearly enough for families to make a decision.\nPlease complete the item details and submit it again for review.',
    code: 'rejected',
  },
  BLANK_MACRO,
]

/** Replaces `{token}` placeholders in a macro body with the record's values. */
export function applyMacroTokens(
  body: string,
  tokens: Record<string, string | undefined> = {}
) {
  return Object.entries(tokens).reduce(
    (text, [token, value]) =>
      text.split(`{${token}}`).join(value?.trim() ? value : ''),
    body
  )
}
